import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store/store';
import App from './components/App';
import './scss/styles.scss';
import { BrowserRouter } from 'react-router-dom';
import Auth from './components/Auth';
import {enableMapSet} from "immer"
import { ToastContainer } from 'react-toastify';
import TooltipContentContainer from './components/TooltipContentContainer';
import Tos from './components/Tos';
import axios from 'axios';
import CustomSelectDropdownContainer from './components/CustomSelectDropdownContainer';

enableMapSet();

// DEFAULT HEADERS
// this sets the defaults for the global axios 
// instance - the authenticated one has it's own defaults
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <TooltipContentContainer />
            <CustomSelectDropdownContainer />
            
            <Auth>
                <Tos>
                    <App />
                </Tos>
            </Auth>

            <ToastContainer position="top-right" autoClose={5000} newestOnTop={true} closeOnClick={false} />
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);
